import type { WorldFeature } from '../types';
import { shipsFeature } from './shipsFeature';

export const HARBOUR_FEATURES: readonly WorldFeature[] = [shipsFeature];

export { shipsFeature } from './shipsFeature';
export type { ShipType, SailState, ShipTemplate } from './shipTemplates';
export { SHIP_TEMPLATES, SHIP_DECK, WIND_HEADING } from './shipTemplates';
export type { PlacedShip, AnchorageData, PalisadeSegment } from './shipPlacement';
export { placeAnchorageShips } from './shipPlacement';
export type { BerthData } from './shipBerths';
export { placeBerthShips } from './shipBerths';
export type { MooringData, Quayside } from './mooredBoats';
export { placeMooredBoats } from './mooredBoats';
export type { PalisadeData, PalisadeOutput } from './palisade';
export { placePiles, buildPalisadeBeam, extractPalisadeSegments } from './palisade';
export type { ShipMotionParams, ShipInstance } from './shipMotion';
export { generateMotionParams, computeMotion, writeShipPose } from './shipMotion';
